import { Box, Typography } from "@mui/material";
import React from "react";
import { SalesAidsStyles } from "../component/app/admin/dealership/tabs/SalesAidsStyles";
import { AddCircleOutline } from "@mui/icons-material";
import Theme from "./Theme";
import AppButton from "../component/base/AppButton.component";

const AddIconUtils = (args) => {
  const { artifacts, handleAddNew, total } = args;
  return (
    <Box sx={SalesAidsStyles.addNewBox}>
      <Box sx={SalesAidsStyles.appButtonBox}>
        <AddCircleOutline
          sx={{
            fontSize: "15px",
            color:
              artifacts?.length >= total
                ? Theme.palette.action.disabled
                : Theme.palette.primary.main,
          }}
        />
        <AppButton
          variant={"text"}
          buttonText={"Add New"}
          size={"small"}
          sx={{ textDecoration: "underline" }}
          clickHandler={() => handleAddNew("text")}
          disabled={artifacts?.length >= total}
        />
      </Box>
      <Typography variant="body2" fontSize={"12px"}>
        {artifacts?.length}/{total}
      </Typography>
    </Box>
  );
};

export default AddIconUtils;
